// Cantourage
export const CANTOURAGE_STRAINS = [
  {
    id: "cantourage-mac-1-25",
    name: "Mac 1",
    producer: "Cantourage",
    country: "Kanada",
    genetics: "Hybryda",
    lineage: "Miracle Alien Cookies",
    thc: 25, cbd: 1.0,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Cytrusowy", "Ziemisty", "Słodki"],
    description: "Limonen odpowiada za działanie poprawiające nastrój, nadając suszowi świeżego, energetyzującego aromatu. Wysoka zawartość THC i kariofilen przyczyniają się do działania przeciwbólowego i przeciwzapalnego. Pacjenci chwalą odmianę za energetyzujące pobudzenie i wyraźną ulgę w bólu, bez uczucia otępienia, dzięki czemu jest ona odpowiednia do stosowania zarówno w godzinach rannych, jak i popołudniowych, potwierdzając swoją przynależność do zrównoważonych hybryd.",
    terpenes: { pinen: 25, kariofilen: 25, limonen: 25, linalol: 25 },
    dominantTerpene: "Pinen", packaging: "10g"
  },
  {
    id: "cantourage-gelato-33-26",
    name: "Gelato 33",
    producer: "Cantourage",
    country: "Kanada",
    genetics: "Hybryda",
    lineage: "Sunset Sherbert × Thin Mint Girl Scout Cookies",
    thc: 26, cbd: 1.0,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Miętowy", "Waniliowy", "Słodki"],
    description: "Limonen odpowiada za działanie euforyczne i poprawiające nastrój, które przechodzi w relaks i odprężenie, co zawdzięczamy zawartości mircenu i linalolu. Susz poprawia koncentrację i skupienie, bez większej sedacji czy senności, charakterystycznych dla niektórych odmian konopi z wyższą zawartością THC. Doceniany za wszechstronność — według Pacjentów pobudza, motywuje i jednocześnie relaksuje ciało, bez natłoku myśli ani paranoi, z aromatem porównywanym do MAC 1.",
    terpenes: { linalol: 25, mircen: 25, limonen: 25, farnezen: 25 },
    dominantTerpene: "Linalol", packaging: "10g"
  },
  {
    id: "cantourage-pave-s1-27",
    name: "Pavé S1",
    producer: "Cantourage",
    country: "Kanada",
    genetics: "Hybryda",
    lineage: "Paris OG × The Menthol",
    thc: 27.3, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Miętowy", "Owocowy", "Paliwowy", "Pikantny", "Słodki"],
    description: "Wysoka zawartość THC i obecność kariofilenu odpowiada za działanie przeciwbólowe i przeciwzapalne, które wzmaga pinen, a w wyższych dawkach susz działa silnie odprężająco i uspokajająco dzięki zawartości linalolu. Dodatkowo Producent deklaruje silne działanie oreksygenne (poprawiające apetyt, wzmagające łaknienie) tej odmiany. Według Pacjentów odmiana odpowiednia do stosowania w ciągu dnia, dopiero przy wyższych dawkach zauważalne jest działanie sedujące.",
    terpenes: { kariofilen: 20, limonen: 20, farnezen: 20, pinen: 20, linalol: 20 },
    dominantTerpene: "Kariofilen", packaging: "10g"
  },
  {
    id: "cantourage-modified-gas-26",
    name: "Modified Gas",
    producer: "Cantourage",
    country: "Kanada",
    genetics: "Hybryda",
    lineage: "First Class Funk × Grape Gasoline",
    thc: 26.3, cbd: 1.0,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Korzenny", "Lawendowy", "Owocowy", "Pieprzowy", "Słodki", "Ziemisty"],
    description: "Limonen odpowiada za działanie poprawiające nastrój, pobudzające i przeciwdepresyjne. Efekty te równoważone są dzięki linalolowi, który uspokaja bez zbędnej sedacji i mircenowi - ten również wykazuje działanie uspokajające, ale przy wyższych dawkach może powodować senność i znużenie. Odmiana działa na początku aktywizująco, dopiero z czasem dając zrelaksowanie i zmniejszenie napięcia mięśniowego.",
    terpenes: { limonen: 20, farnezen: 20, linalol: 20, mircen: 20, kariofilen: 20 },
    dominantTerpene: "Limonen", packaging: "10g"
  },
  {
    id: "cantourage-orange-cake-279",
    name: "Orange Cake",
    producer: "Cantourage",
    country: "Kanada",
    genetics: "Hybryda/Indica",
    lineage: "Mimosa × Orangeade",
    thc: 27.9, cbd: 1.0,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Cytrusowy", "Korzenny", "Owocowy", "Słodki", "Ziemisty"],
    description: "Pierwsza hybryda z dominantą indica od Cantourage na polskim rynku, o charakterystycznej, cytrusowej woni, dzięki zawartości limonenu. To właśnie limonen odpowiada za efekty poprawiające nastrój i działanie przeciwdepresyjne. Dodatkowo obecne w profilu terpenowym pinen i mircen wykazują działanie przeciwbólowe i zmniejszające stan zapalny oraz zmniejszenie lęku, co jest szczególnie ważne przy tak wysokim stężeniu THC.",
    terpenes: { limonen: 30, farnezen: 25, pinen: 25, mircen: 20 },
    dominantTerpene: "Limonen", packaging: "10g"
  },
  {
    id: "cantourage-slurricane-mint-253",
    name: "Slurricane Mint",
    producer: "Cantourage",
    country: "Kanada",
    genetics: "Hybryda/Indica",
    lineage: "Slurricane × Margy's Mint",
    thc: 25.3, cbd: 1.0,
    availability: "Brak", effect: "Relaksujące",
    aromas: ["Miętowy", "Diesel"],
    description: "Hybryda z dominantą indica od Cantourage dzięki obfitej zawartości mircenu działa nasennie i relaksująco. Wysokie stężenie kariofilenu i pinenu odpowiada za efekty przeciwbólowe i zmniejszające stan zapalny. Producent dodatkowo deklaruje znaczącą poprawę apetytu i zwiększone łaknienie po spożyciu suszu.",
    descriptionEn: "An indica-dominant hybrid from Cantourage that, thanks to its abundant myrcene content, acts as a sleep aid and relaxant. The high concentration of caryophyllene and pinene is responsible for its analgesic and anti-inflammatory effects. The producer additionally declares a significant improvement in appetite and increased hunger after using the flower.",
    terpenes: { mircen: 25, kariofilen: 25, limonen: 25, pinen: 25 },
    dominantTerpene: "Mircen", packaging: "10g",
    dateAdded: "2026-09-20"
  }
];